/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminRedriveStuckFlowRunsRequest
 */
export interface AdminRedriveStuckFlowRunsRequest {
    /**
     * 
     */
    olderThanMinutes?: number;
    /**
     * 
     */
    prefix?: string | null;
    /**
     * 
     */
    dryRun?: boolean;
}

/**
 * Check if a given object implements the AdminRedriveStuckFlowRunsRequest interface.
 */
export function instanceOfAdminRedriveStuckFlowRunsRequest(value: object): value is AdminRedriveStuckFlowRunsRequest {
    return true;
}

export function AdminRedriveStuckFlowRunsRequestFromJSON(json: any): AdminRedriveStuckFlowRunsRequest {
    return AdminRedriveStuckFlowRunsRequestFromJSONTyped(json, false);
}

export function AdminRedriveStuckFlowRunsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminRedriveStuckFlowRunsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'olderThanMinutes': json['older_than_minutes'] == null ? undefined : json['older_than_minutes'],
        'prefix': json['prefix'] === undefined ? undefined : json['prefix'] === null ? null : json['prefix'],
        'dryRun': json['dry_run'] == null ? undefined : json['dry_run'],
    };
}

export function AdminRedriveStuckFlowRunsRequestToJSON(json: any): AdminRedriveStuckFlowRunsRequest {
    return AdminRedriveStuckFlowRunsRequestToJSONTyped(json, false);
}

export function AdminRedriveStuckFlowRunsRequestToJSONTyped(value?: AdminRedriveStuckFlowRunsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'older_than_minutes': value['olderThanMinutes'],
        'prefix': value['prefix'],
        'dry_run': value['dryRun'],
    };
}

